'use client';

import React from 'react';
import { Chip } from '@mui/material';
import { useErrorCounts } from '@/contexts/ErrorCountsContext';

export const SuggestedFixesChip: React.FC = () => {
  const { totalErrors, loading } = useErrorCounts();

  if (loading || totalErrors === 0) {
    return null;
  }

  // Pluralization-aware accessible name so the bare count isn't read as an
  // undescribed "5". role='img' makes the aria-label reliably the accessible name
  // (an unadorned Chip is a generic <div>, where aria-label isn't guaranteed),
  // matching unhealthy-chip.tsx and AISuggestedFixesChip.
  return (
    <Chip
      label={totalErrors.toLocaleString('en-US')}
      color='error'
      size='small'
      role='img'
      aria-label={`${totalErrors.toLocaleString('en-US')} unresolved error${totalErrors === 1 ? '' : 's'}`}
    />
  );
};
